import classNames from 'classnames';
import styles from './TopWelcomeBlock.module.scss';
import Link from 'Components/shared/Link/Link';
import {
  EBaseButtonSize,
  EButtonBorderRadiusStrength,
  EButtonTextAlign,
} from '@spinwise/react-component-library/ButtonAbstract';
import { PATHS } from 'Libraries/routes.library';
import { EBrandButtonTypes } from 'Libraries/buttons.library';
import { t } from 'i18next';
import DepositSelectSumManager from '../../../shared/DepositSelectSumManager/DepositSelectSumManager';
import { Trans } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';
import { isServer } from 'Utils/index';
import TermsDisclaimer from '../../../blocks/TermsDisclaimer/TermsDisclaimer';
import parse from 'html-react-parser';
import { useRouter } from 'next/router';
import { ButtonTextOnly } from '@spinwise/react-component-library/ButtonTextOnly';
import { EBaseTextSize, EBaseTextWeight } from '@spinwise/react-component-library/BaseText';
import useShowAuthButtons from 'Hooks/useShowAuthButtons';
import { ETitles, RegTypes } from 'Types/globals';
import { useStrapiTitles } from 'Hooks/strapi-titles';
import { useSelector } from 'react-redux';
import { IApplicationState } from '@spinwise/spinwise-core';

const { ClientJS } = isServer() ? { ClientJS: () => {} } : require('clientjs');
interface ITopWelcomeBlock {
  regtype: RegTypes;
  theme: {
    fallback_image: {
      url: string;
    };
    mobile: {
      mime: string;
      url: string;
    };
    desktop: {
      mime: string;
      url: string;
    };
    desktop_xl: {
      mime: string;
      url: string;
    };
    desktop_xxl: {
      mime: string;
      url: string;
    };
    top_banner_line: {
      mime: string;
      url: string;
    };
    top_banner_line_xl: {
      mime: string;
      url: string;
    };
    top_banner_line_xxl: {
      mime: string;
      url: string;
    };
  };
}
const TopWelcomeBlock = ({ theme }: ITopWelcomeBlock) => {
  const [showBottomContainer, setShowBottomContainer] = useState(false);
  const contentContainerRef = useRef<HTMLDivElement>();
  const mainContainerRef = useRef<HTMLDivElement>();
  const router = useRouter();
  const regtype = useSelector((state: IApplicationState) => state.globalReducer?.geo?.reg_type);
  const showRegisterButton = useShowAuthButtons();
  const [welcome_bonus_text] = useStrapiTitles([ETitles.WELCOME_BONUS_TEXT]);

  useEffect(() => {
    const availableSpace = (mainContainerRef.current.offsetHeight - contentContainerRef.current.offsetHeight) / 2;
    if (
      contentContainerRef.current.offsetHeight <= mainContainerRef.current.offsetHeight / 1.56 - 18 &&
      availableSpace > 150
    ) {
      setShowBottomContainer(true);
    }
  }, [contentContainerRef?.current?.offsetHeight]);

  const getTopOffset = () => {
    if (mainContainerRef && mainContainerRef?.current?.offsetWidth >= 834) return 'd-fl ai-c jc-c';

    if (
      (regtype == RegTypes.PAYPLAY_T && showBottomContainer == true) ||
      (regtype == RegTypes.PAYPLAY_Z && showBottomContainer == true)
    ) {
      return 'd-fl ai-fs jc-c';
    } else return 'd-fl ai-c jc-c';
  };

  const [themeConfig, SetThemeConfig] = useState({});
  const [canPlayVideoMobile, SetCanPlayVideoMobile] = useState(true);
  const gradientRef = useRef(null);

  const mobileVideoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    SetThemeConfig({
      '--mobile': `${
        theme.mobile.mime === 'image/jpeg'
          ? `url(${theme.mobile.url})`
          : theme.mobile.mime === 'video/mp4'
          ? ''
          : 'url(/images/homepage/header-tablet-mobile.jpg)'
      }`,
      '--desktop': `${
        theme.desktop.mime === 'image/jpeg'
          ? `url(${theme.desktop.url})`
          : theme.desktop.mime === 'video/mp4'
          ? ''
          : 'url(/images/homepage-c/d-header.jpg)'
      }`,
    });
    const client = new ClientJS();
    var isMobileIOS = client.isMobileIOS(); // Check For Mobile iOS]
    if (isMobileIOS) {
      mobileVideoRef?.current
        ?.play?.()
        .then(() => {})
        .catch(error => {
          //Do something like adding controls to allow user to manually play
          SetThemeConfig({
            ...themeConfig,
            '--mobile': `url(${theme?.fallback_image?.url})`,
          });
          SetCanPlayVideoMobile(false);
        });
    }
  }, []);

  const getDepositComponent = () => {
    switch (regtype) {
      case RegTypes.EMAIL:
        if (!showRegisterButton) return null;

        return (
          <div className={classNames(styles.cta_container, 'd-fl jc-c ai-c')}>
            <Link
              href={{
                pathname: PATHS.REGISTER,
                query: {
                  ...router.query,
                },
              }}
              className="w-100"
              data-qa="button-hero-register"
            >
              <ButtonTextOnly
                label={t('homepage.c2.create.account.btn')}
                type={EBrandButtonTypes.Tertiary}
                size={EBaseButtonSize.Medium}
                textSize={EBaseTextSize.Large}
                fullWidth={true}
                textWeight={EBaseTextWeight.W600}
                alignText={EButtonTextAlign.Center}
                borderRadius={EButtonBorderRadiusStrength.Seven}
              />
            </Link>
          </div>
        );
      case RegTypes.PAYPLAY_T:
      case RegTypes.PAYPLAY_Z:
        return (
          <>
            <DepositSelectSumManager viewVersion="C" />
            <TermsDisclaimer />
          </>
        );
    }
  };

  const replayVideo = () => {
    mobileVideoRef?.current?.play?.();
  };

  return (
    <>
      <div className={`${styles.top_welcome_block}`} ref={mainContainerRef}>
        <div
          className={`${styles.top_welcome_block_inner} ${
            !theme?.mobile?.mime ? styles.top_welcome_block_inner__fallback : styles.top_welcome_block_inner__video
          }`}
          style={themeConfig as React.CSSProperties}
        >
          <div className={`${styles.content_container} ${getTopOffset()}`}>
            <div
              className={`${styles.content_container_inner} d-fl ai-c jc-c fd-c`}
              ref={contentContainerRef}
              style={{
                paddingTop:
                  (regtype == RegTypes.PAYPLAY_T && showBottomContainer == true) ||
                  (regtype == RegTypes.PAYPLAY_Z && showBottomContainer == true)
                    ? '80px'
                    : '0px',
                marginBottom: showBottomContainer == true ? '80px' : '0px',
              }}
            >
              <p className={`${styles.title}`}>
                <Trans components={{}} transKeepBasicHtmlNodesFor>
                  {t(`homepage.c2.top.banner.title`)}
                </Trans>
              </p>
              <p className={`${styles.subtitle}`}>{parse(`${welcome_bonus_text}`)}</p>
              <div className={`${styles.deposit_container}`}>{getDepositComponent()}</div>
            </div>
          </div>

          {showBottomContainer == true && (
            <div
              className={`${styles.bg_container} d-fl ai-fe fd-c jc-c ${
                !theme?.mobile?.mime ? styles.fallback_image_mobile : ''
              }`}
            >
              {theme.mobile.mime === 'video/mp4' && canPlayVideoMobile && (
                <div className={`${styles.video_container} d-fl ai-fe jc-c`}>
                  <div className={styles.gradient_video} ref={gradientRef}></div>
                  <video
                    ref={mobileVideoRef}
                    playsInline
                    autoPlay
                    muted
                    preload="metadata"
                    poster="/images/mobile-video-poster.png"
                    onEnded={() => {
                      setTimeout(replayVideo, 5000);
                    }}
                  >
                    <source src={theme.mobile.url} type="video/mp4" />
                  </video>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default TopWelcomeBlock;
